// src/lib/kinema/core/handlers/selectionHandlers.ts
import type { EditorState, InverseOperation } from '../types';
import { SELECT_LAYER } from '../commands/commands';
import { cloneState } from '../EditorState';

export function handleSelectLayer(
  state: EditorState,
  payload: { layerId: string | null; addToSelection?: boolean; _restoreIds?: string[] },
): { state: EditorState; inverse: InverseOperation | null } {
  const newState = cloneState(state);
  const oldSelectedIds = new Set(state.selectedIds);
  const oldPrimary = state.primarySelectedId;

  if (payload._restoreIds) {
    // Undo path: restore exact previous selection state
    newState.selectedIds = new Set(payload._restoreIds);
    newState.primarySelectedId = payload.layerId;
  } else if (payload.layerId === null) {
    // Deselect all
    newState.selectedIds = new Set();
    newState.primarySelectedId = null;
  } else if (payload.addToSelection) {
    // Toggle in multi-select
    if (newState.selectedIds.has(payload.layerId)) {
      newState.selectedIds.delete(payload.layerId);
      if (newState.primarySelectedId === payload.layerId) {
        newState.primarySelectedId =
          newState.selectedIds.size > 0 ? Array.from(newState.selectedIds)[0] : null;
      }
    } else {
      newState.selectedIds.add(payload.layerId);
      newState.primarySelectedId = payload.layerId;
    }
  } else {
    // Single select — replace selection
    newState.selectedIds = new Set([payload.layerId]);
    newState.primarySelectedId = payload.layerId;
  }

  return {
    state: newState,
    inverse: {
      command: SELECT_LAYER,
      payload: { layerId: oldPrimary, _restoreIds: Array.from(oldSelectedIds) },
    },
  };
}
